module.exports = __webpack_public_path__ + "img/Dislike-new.ac0036a0.svg";